import { CSSProperties } from "react"

export const HighlighterIcon = ({style}: {style?:CSSProperties}) => {
  return <svg viewBox='0 0 64 64' style={style}>
    <g id='surface1'>
      <path
        style={{
          stroke:'none',
          fill:'rgb(80%,80%,80%)',
        }}
        d="M 4.28125,55.332031 11.560934,45.856751 16.378319,31.183706 41.571891,5.4179406 50.354204,0.94320304 63.343918,14.768338 58.515485,24.717317 34.28772,50.309726 20.363281,53.636719 12.996094,60.570312 Z"
      />
      <path
        style={{
          stroke:'none',
          fillRule:'nonzero',
          fill:'rgb(0%,0%,0%)',
        }}
        d='M 62.4375 10.902344 L 53.640625 1.691406 C 51.0625 -0.90625 47.695312 -0.195312 45.929688 1.691406 L 44.34375 3.351562 C 42.832031 2.417969 40.742188 2.613281 39.472656 3.941406 L 14.476562 30.121094 L 10.070312 45.363281 L 0 55.910156 L 13.453125 64 L 20.722656 56.386719 L 35.214844 51.839844 L 60.285156 25.582031 C 61.59375 24.214844 61.761719 22.097656 60.800781 20.535156 L 62.4375 18.820312 C 64.519531 16.636719 64.519531 13.085938 62.4375 10.902344 Z M 12.996094 60.570312 L 4.28125 55.332031 L 11.265625 48.019531 L 18.125 55.199219 Z M 20.363281 53.636719 L 12.792969 45.707031 L 16.933594 32.695312 L 32.789062 49.300781 Z M 58.34375 23.707031 L 35.214844 47.933594 L 18.207031 30.121094 L 41.410156 5.820312 C 41.878906 5.328125 42.671875 5.328125 43.140625 5.820312 L 58.347656 21.742188 C 58.855469 22.277344 58.855469 23.175781 58.34375 23.707031 Z M 60.496094 16.945312 L 58.996094 18.515625 L 46.296875 5.214844 L 47.871094 3.566406 C 48.898438 2.488281 50.671875 2.488281 51.703125 3.566406 L 60.496094 12.777344 C 61.59375 13.925781 61.59375 15.796875 60.496094 16.945312 Z M 60.496094 16.945312 '
      />
    </g>
</svg>
}